export default __webpack_public_path__ + "static/media/build.2aa958f0.png";